export {IdeasWallModule} from './core/ideas-wall.module';
